/* eslint-disable no-shadow */
const SmithWatermanGotoh = (str1, str2) => {
    let matchValue = 1;
    let mismatchValue = -2;
    let gapValue = -0.5;

    function compareCharacters(
        a,
        aIndex,
        b,
        bIndex,
        matchValue,
        mismatchValue,
    ) {
        if (
            a[aIndex].localeCompare(b[bIndex], 'en', {sensitivity: 'base'}) ===
            0
        ) {
            return matchValue;
        } else {
            return mismatchValue;
        }
    }

    //get the maxDistance which is the smallest number of characters between str1 and str2 multiplied by
    //the largest of matchValue and gapValue
    let maxDistance =
        Math.min(str1.length, str2.length) * Math.max(matchValue, gapValue);

    let v0 = [];
    let v1 = [];
    let str1Length = str1.length;
    let str2Length = str2.length;

    //do the smith waterman similarity measure (currentMax)
    v0[0] = Math.max(
        0,
        gapValue,
        compareCharacters(str1, 0, str2, 0, matchValue, mismatchValue),
    );
    let currentMax = v0[0];

    for (let j = 1; j < str2Length; j++) {
        v0[j] = Math.max(
            0,
            v0[j - 1] + gapValue,
            compareCharacters(str1, 0, str2, j, matchValue, mismatchValue),
        );

        currentMax = Math.max(currentMax, v0[j]);
    }

    for (let i = 1; i < str1Length; i++) {
        v1[0] = Math.max(
            0,
            v0[0] + gapValue,
            compareCharacters(str1, i, str2, 0, matchValue, mismatchValue),
        );

        currentMax = Math.max(currentMax, v1[0]);

        for (let j = 1; j < str2Length; j++) {
            v1[j] = Math.max(
                0,
                v0[j] + gapValue,
                v1[j - 1] + gapValue,
                v0[j - 1] +
                    compareCharacters(
                        str1,
                        i,
                        str2,
                        j,
                        matchValue,
                        mismatchValue,
                    ),
            );

            currentMax = Math.max(currentMax, v1[j]);
        }

        for (let j = 0; j < str2Length; j++) {
            v0[j] = v1[j];
        }
    }

    return currentMax / maxDistance;
};

export default SmithWatermanGotoh;
